export default function Popover() {
  return {
    MuiPopover: {
      styleOverrides: {
        root: {
          zIndex: 2000,
          '.MuiPopover-paper': {
            overflow: 'visible'
          }
        }
      }
    }
  };
}
